'use strict';

(function ($) {
    $.agito = $.agito || {};
    $.agito.absence = $.agito.absence || {};
    $.agito.competences = $.agito.competences || {};

    $.agito.configureHelpPage = function (entityId, formId) {
        $.agito.hrmPage.quickEditDialog(entityId, formId, null, null, null, 'A7E9FA8F-2CA5-4B0D-9A71-658041C9A0EA');
    };

    $.agito.absence.getButtonState = function (StatusId, PersonId, currentPerson, admin) {

        var AbsenceStatus_Announcement = "48C9AF1B-C527-41CD-9A4B-471E91CE201A";
        var AbsenceStatus_Canceled = "55AA7F41-0185-4BF4-81D9-3AE69D7B6A32";
        var AbsenceStatus_Approved = "F28EF06C-1E9F-4BB1-859A-16D6162D6282";
        var AbsenceStatus_InApproval = "B163FBC1-2447-4CB8-B8E5-B66D55FBBC7F";

        var canDelete = (StatusId.toUpperCase() == AbsenceStatus_Announcement || StatusId.toUpperCase() == AbsenceStatus_Canceled);
        var canCancel = (StatusId.toUpperCase() == AbsenceStatus_InApproval || StatusId.toUpperCase() == AbsenceStatus_Approved);

        if (!admin && PersonId.toUpperCase() != currentPerson.toUpperCase())
        {
            canDelete = false;
        }

        if (PersonId.toUpperCase() != currentPerson.toUpperCase())
        {
            canCancel = false;
        }

        return { "canDelete": canDelete, "canCancel": canCancel };
    }
    $.agito.openPersonCard =  function (personId) {
        UrlHelpers.OpenBrowserTab($.agito.baseUrl + 'DynamicForm/Form?entityId=e518f04d-f9de-4d44-bf9f-72fa0e6acb91&formGroupId=07DB43A7-72F1-476C-B742-8AC453F99B0F&entityInstanceId=' + personId, true, '65d837cb-c5c2-4991-bd55-e7aff59a9730');    
    }

    $.agito.openEducationProgramme = function (EducationProgrammeId) {
        UrlHelpers.OpenBrowserTab($.agito.baseUrl + 'DynamicForm/Form?entityId=34BE9E20-5938-47AC-A2A7-F3AD9539D96C&formGroupId=0b12e43d-01e9-4ef1-a306-7ee9ca3151ed&entityInstanceId=' + EducationProgrammeId, true, '65d837cb-c5c2-4991-bd55-e7aff59a9730');
    }

    $.agito.testUrl = function (link) {
        var splitLink = link.split(':');
        if (!(splitLink[0] == "http" || splitLink[0] == "https")) {
            link = "https://" + link;
        }
        window.open(link);
    }

    $.agito.iniGridColumnTooltips = function (tooltipInfo, gridSelector, gridElementControl) {

        var $gridElementControl = null;
        if (gridSelector) {
            $gridElementControl = $(gridSelector).control();
        }
        else {
            $gridElementControl = gridElementControl;
        }

        var items = [];
        tooltipInfo.forEach(function (tooltipColumn) {
            items.push('[aria-describedby$=' + Object.keys(tooltipColumn)[0] + '][role=gridcell]');
        });

        $($gridElementControl.rootElement).uitooltip({
            track: true,
            items: items.join(","),
            tooltipClass: 'grid-tooltip',
            content: function (callback) {
                return buildGridTooltipContent([]);
            },
            open: function (evt, ui) {
                var id = $(evt.originalEvent.target).closest("tr").attr("data-id");
                var format = $.ig.regional.defaults.datePattern.toUpperCase();
                var tooltipData = [];

                var columns = [];
                var currentColumn = $(evt.originalEvent.target).attr("aria-describedby"); 
                tooltipInfo.forEach(function (tooltipColumn) {
                    if (currentColumn.includes(Object.keys(tooltipColumn)[0])) {
                        columns = tooltipColumn[Object.keys(tooltipColumn)[0]];
                        return;
                    }
                });

                $gridElementControl.data.Value.Data.forEach(function (view) {
                    if (id === view.RecordID || id === view._001_RecordId) {
                        var tooltipItemData = {};
                        if ($gridElementControl.data.Views[0].Columns)
                            $gridElementControl.data.Views[0].Columns.forEach(function (column) {
                                if (columns.includes(column.BaseName)) {

                                    if (column.JsType == "date" && view[column.BaseName] != "" && view[column.BaseName] != null) {
                                        tooltipItemData[column.DisplayName] = moment(view[column.BaseName]).format(format);

                                    }
                                    else {
                                        tooltipItemData[column.DisplayName] = view[column.BaseName];
                                    }
                                }
                            });
                        else
                            $gridElementControl.data.Columns.forEach(function (column) {
                                if (columns.includes(column.BaseName)) {

                                    if (column.Editor == "Agitavit.Controls.AgDateControl" && view[column.BaseName] != "" && view[column.BaseName] != null) {
                                        tooltipItemData[column.DisplayName] = moment(view[column.BaseName]).format(format);

                                    }
                                    else {
                                        tooltipItemData[column.DisplayName] = view[column.BaseName];
                                    }
                                }
                            });
                        tooltipData.push(tooltipItemData);

                        $(evt.currentTarget).uitooltip("option", "content", buildGridTooltipContent(tooltipData));
                        return;
                    }
                });
            },
            show: { delay: 500, duration: 0 },
            hide: { delay: 0, duration: 0 },
            position: { my: 'left top+5', at: 'left bottom', collision: 'flipfit' }
        });
    }

    function buildGridTooltipContent(data) {
        var content = '<table class="grid-tooltip-content"><tbody>';
        content += buildGridTooltipContentHelper(data, 0);
        content += '</tbody></table>';
        return $(content);
    }

    function buildGridTooltipContentHelper(data, level) {
        var content = '';
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                if (data[key] instanceof Object) {
                    content += buildGridTooltipContentHelper(data[key], level + 1);
                } else {
                    content += '<tr><td class="grid-tooltip-key">';
                    for (var i = 0; i < level; i++)
                        content += key.trim() + '&nbsp;&nbsp;&nbsp;&nbsp;</td> <td class="grid-tooltip-value">' + (data[key] ? data[key] : '') + '</td>';
                    content += '</tr>';
                }
            }
        }
        return content;
    }

    $.agito.competences.submitForm = function (dialogSelector, reloadOnSuccess, successCallback, failureCallback) {

        var $dialog = $(dialogSelector).closest('.modal');
        var $form = $dialog.find('form');
        var button = $dialog.find('.btn-submit');

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',

            data: new FormData($form[0]),
            cache: false,
            contentType: false,
            processData: false
        })
            .done(function (data) {

                if (data != null && data.hasOwnProperty('success')) {
                    if (!data.success) {

                        var messagesPlaceholder = $dialog.find('.hrm-page-messages-placeholder');

                        if (messagesPlaceholder.length > 0)
                            $.agito.hrmPage.handleAjaxError(messagesPlaceholder, data);
                        else
                            alert(data.message);

                        return;
                    }
                    else if (typeof data.message != "undefined") {
                        var messagesPlaceholder = $('.hrm-page-placeholder .hrm-page-messages-placeholder').first();

                        if (messagesPlaceholder.length > 0)
                            $.agito.hrmPage.handleAjaxError(messagesPlaceholder, data);
                        else
                            alert(data.message);
                    }
                }

                $form.trigger('agito.competences.saved');

                if ($.isFunction(successCallback)) {
                    successCallback.call(this, data);
                }
                if (!!reloadOnSuccess) {
                    window.location.href = window.location.href;
                }
            }).fail($.isFunction(failureCallback) ? failureCallback : function (jqXHR, textStatus) {
            });
    }

    $.agito.hrmPage.showCommentDialog = function (titleText, confirmText, abortText, buttonId, successCallback) {

        // save button presseed information
        $('#ButtonPressed').val(buttonId);
        //if contains modal
        if ($('.modal-body form').length != 0) {
            var buttons = $("[id=ButtonPressed]");
            for (i = 0; i < buttons.length; i++) {
                $(buttons[i]).val(buttonId);
            }
        }
        
        var placeholder = $.agito.hrmPage.createDialogPlaceholder();
        var $modal = $(placeholder);
        var $modalContent = $('.modal-content', $modal);

        $modalContent.empty();
        $modal.modal('show');
        $modal.css({
            '--hrm-desired-dialog-width': "670px"
        });
        
        var textArea = $('<textarea class="form-control" style="height:107px;"></textarea>');

        $modalContent.prepend($('<div class="modal-header hrm-modal-header"><div class="hrm-modal-header_left"><h4 class="modal-title">' + titleText + '</h4></div><div class="hrm-modal-header_right"><span data-testid="dialog_btn_header_close" class="hrm-modal-header_button hrm-modal-header_buttons-close ph ph-x" data-bs-dismiss="modal" aria-label="Close"></span></div></div>'));
        $modalContent.append($('<div class="modal-body"' + (($.agito.isMobileDevice || $.agito.isMobileApp) ? '' : 'min-width:670px;') + '"></div>').append(textArea));

        var footer = $('<div class="modal-footer hrm-modal-footer"></div>');

        footer.prepend($('<button type="button" class="btn btn-primary" data-bs-dismiss="modal" style="outline:none;">' + confirmText + '</button>').click(function () {
            $('[data-basename="Workflow_Comment"]').find('input').val(textArea.val());
            $.agito.hrmPage.submitForm(successCallback, true);
        }));

        footer.prepend('<button type="button" class="btn btn-default btn-close" data-bs-dismiss="modal" style="outline:none;">' + abortText + '</button>');

        $modalContent.append(footer);

        textArea.focus();

        return;
    }

    $.agito.isParentEnterpriseId = function () {
        return $.agito.selectedEnterprise == $.agito.parentEnterprise && $.agito.selectedEnterprise != '';
    };

    $.agito.absence.openAbsenceForm = function (admin, personAbsenceId, statusId, personId, openInNewTab) {

        var personAbsenceEntityId = "6086d283-b860-45b7-bf14-963c42a1ed54";
        var personAbsenceRecordingFormGroupId = "29C36D91-E4C1-4F31-A603-C16E7E7D007C";

        var personAbsenceRecordingFormGroup = "29C36D91-E4C1-4F31-A603-C16E7E7D007C";
        var personAbsenceReadonlyFormGroup = "F12C3EEA-DD2F-44A4-8167-AF13FE023C33";
        var personAbsenceEditFormGroup = "E87CFE84-82CD-46E9-A00C-DBB82E74BEE0";
        var personAbsenceCancelFormId = "a26d4973-ea4c-4d69-a735-8915959e33e8";

        var absenceStatus_Announcement = "48C9AF1B-C527-41CD-9A4B-471E91CE201A";
        var absenceStatus_InApproval = "B163FBC1-2447-4CB8-B8E5-B66D55FBBC7F";
        var absenceStatus_Approved = "F28EF06C-1E9F-4BB1-859A-16D6162D6282";

        var readFormGroupId = admin ? personAbsenceRecordingFormGroup : personAbsenceReadonlyFormGroup;

        $.get($.agito.baseUrl + 'PersonnelRecords/PersonAbsence/GetAbsenceApprovalTaskUrl', {
            absenceId: personAbsenceId
        },  function (res)
            {
                if (!res.success)
                {
                    $.agito.hrmPage.handleAjaxError('.hrm-page-messages-placeholder', res);
                    return;
                }

                if (res.result !== "" && personId != $.agito.currentPersonId)
                {
                    var url = $.agito.baseUrl + res.result;
                    UrlHelpers.OpenBrowserTab(url, openInNewTab);
                }
                else
                {
                    if (statusId.toUpperCase() == absenceStatus_Announcement && personId == $.agito.currentPersonId) {
                        var url = $.agito.baseUrl + 'DynamicForm/Form?entityInstanceId=' + personAbsenceId + '&formGroupId=' + personAbsenceEditFormGroup;
                        UrlHelpers.OpenBrowserTab(url, openInNewTab);
                    }
                    else if (statusId.toUpperCase() == absenceStatus_InApproval && personId == $.agito.currentPersonId) {
                        var url = $.agito.baseUrl + 'DynamicForm/Form?entityId=' + personAbsenceEntityId + '&formId=' + personAbsenceCancelFormId + '&entityInstanceId=' + personAbsenceId;
                        UrlHelpers.OpenBrowserTab(url, openInNewTab);
                    }
                    else if (statusId.toUpperCase() == absenceStatus_Approved && personId == $.agito.currentPersonId) {
                        var url = $.agito.baseUrl + 'DynamicForm/Form?entityId=' + personAbsenceEntityId + '&formId=' + personAbsenceCancelFormId + '&entityInstanceId=' + personAbsenceId;
                        UrlHelpers.OpenBrowserTab(url, openInNewTab);                        
                    }
                    else
                    {
                        var url = $.agito.baseUrl + 'DynamicForm/Form?entityInstanceId=' + personAbsenceId + '&formGroupId=' + readFormGroupId;
                        UrlHelpers.OpenBrowserTab(url, openInNewTab);
                    }
                }
        });
        
    };

    function Cancel() {
        var ids = $PersonAbsence.getSelectedRows();
        for (var i = 0; i < ids.length; i++) {
            var url = $.agito.baseUrl + 'DynamicForm/Form?entityId=' + personAbsenceEntityId + '&formId=' + personAbsenceCancelFormId + '&entityInstanceId=' + ids[i];
            UrlHelpers.OpenBrowserTab(url);
        }
    };

    function BIReport() {
        var url = $.agito.baseUrl + 'ReportsAndAnalysis/ReportsAndAnalysis/ReportList/?reportKeys=PersonAbsence&reportKeys=AnnualLeaveOnDate';
        $.agito.hrmPage.loadDialog(url);
    };


    $.agito.openReportDialog = function(reportKeys) {
        var url = $.agito.baseUrl + 'ReportsAndAnalysis/ReportsAndAnalysis/ReportList?reportKeys=' + reportKeys.join('&reportKeys=');
        $.agito.hrmPage.loadDialog(url);
    };

    $.agito.documentDownload = function (url) {
        var downloadNoPrivileges = { userMessages: [{ severity: "Error", message: ($.agito.resources.getResource("DocumentDownloadNoPrivileges")) }] };
        var systemMessage = { userMessages: [{ severity: "Error", message: ($.agito.resources.getResource("Common_UnknownError")) }] };

        fetch($.agito.baseUrl + url)
            .then(response => {
                if (!response.ok) {
                    $.agito.hrmPage.handleAjaxError(undefined, response.status == '403' ? downloadNoPrivileges : systemMessage);

                    return;
                }
                return response.blob().then((data) => {

                    if (data.type == "text/html") {
                        $.agito.hrmPage.handleAjaxError(undefined, response.status == '403' ? downloadNoPrivileges : systemMessage);
                        return;
                    }

                    const header = response.headers.get('Content-Disposition');

                    const parts = header.split(';');
                    var filename = parts[1].split('=')[1];
                    filename = filename.replaceAll('"', '')
                    return {
                        data: data,
                        filename: filename,
                    };
                });
            })
            .then(({ data, filename }) => {
                const blob = new Blob([data]);
                const downloadUrl = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
            });
    }


})($);

